import { render, staticRenderFns } from "./PackagingRequirementsTwo.vue?vue&type=template&id=a0366f7c&scoped=true"
import script from "./PackagingRequirementsTwo.vue?vue&type=script&lang=js"
export * from "./PackagingRequirementsTwo.vue?vue&type=script&lang=js"
import style0 from "./PackagingRequirementsTwo.vue?vue&type=style&index=0&id=a0366f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0366f7c",
  null
  
)

export default component.exports